<div class="adandonedReservationActions__cont">
  <app-ds-button
    [isDisabled]="isLoadingCancellation"
    [labels]="{ ButtonLabel: 'ADANDONED_RESERVATION_MODULE.ACTIONS.YES_CONTINUE' | transloco }"
    (clickEvent)="goToHistoryItem()">
  </app-ds-button>
  <div class="adandonedReservationActions__btnCancel" *ngIf="enabledCancellation">
    <app-ds-button
      [type]="cancelBtnDsType"
      [isLoading]="isLoadingCancellation"
      [labels]="{ ButtonLabel: 'ADANDONED_RESERVATION_MODULE.ACTIONS.NO_CANCEL' | transloco }"
      (clickEvent)="cancel()">
    </app-ds-button>
  </div>
</div>
